// custom-add-to-cart.js
// assets/custom-add-to-cart.js
(function(){
  // Utility: try multiple selectors for cart count (common variants)
  function updateCartCount(count) {
    var selectors = [
      '.site-header__cart-count',
      '.cart-count-bubble',
      '.header-cart-count',
      '.js-cart-count'
    ];
    for (var i = 0; i < selectors.length; i++) {
      var el = document.querySelector(selectors[i]);
      if (el) {
        el.textContent = count;
        // for accessibility: announce change if aria-live region present
        el.setAttribute('aria-live', 'polite');
        return true;
      }
    }
    return false;
  }

  // Simple guard to avoid multiple concurrent clicks on same button
  var inProgress = new WeakSet();

  document.addEventListener('click', function(e){
    var btn = e.target.closest('.add-to-cart-ajax');
    if(!btn) return;

    e.preventDefault();

    // prevent double requests for same element
    if (inProgress.has(btn)) return;
    inProgress.add(btn);

    var variantId = btn.dataset.variantId;
    var handle = btn.dataset.productHandle || '';

    if (!variantId) {
      // fallback to product page for complex products
      inProgress.delete(btn);
      window.location = '/products/' + handle;
      return;
    }

    btn.disabled = true;
    var originalText = (btn.textContent || '').trim();
    btn.textContent = 'Adding...';

    // Optional: set a timeout if fetch hangs (e.g. network issues)
    var didRespond = false;
    var timeout = setTimeout(function(){
      if (!didRespond) {
        console.warn('Add to cart: request timed out.');
        // fallback behaviour
        btn.textContent = 'Add to cart';
        btn.disabled = false;
        inProgress.delete(btn);
      }
    }, 15000); // 15s timeout

    fetch('/cart/add.js', {
      method: 'POST',
      headers: { 'Content-Type': 'application/json' },
      body: JSON.stringify({ id: variantId, quantity: 1 })
    })
    .then(function(resp){
      didRespond = true;
      clearTimeout(timeout);
      if (!resp.ok) throw resp;
      return resp.json();
    })
    .then(function(item){
      // success UI
      btn.textContent = 'Added';
      // update cart count
      return fetch('/cart.js').then(function(r){ return r.json(); });
    })
    .then(function(cart){
      updateCartCount(cart.item_count);
      // if theme exposes a cart drawer open function, call it
      if (typeof window.showCartDrawer === 'function') {
        try { window.showCartDrawer(); } catch(err) { /* ignore */ }
      }
    })
    .catch(function(err){
      console.error('Add to cart failed', err);
      // fallback: go to product page (for safety)
      window.location = '/products/' + handle;
    })
    .finally(function(){
      clearTimeout(timeout);
      // restore button state after a short delay so user sees 'Added'
      setTimeout(function(){
        try {
          btn.disabled = false;
          btn.textContent = originalText || 'Add to cart';
        } catch(e) {}
        inProgress.delete(btn);
      }, 1200);
    });
  });
})();

